import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import {
    getDefaultCourses,
    saveDefaultCourses,
    showCourseDetails,
    hideCourseDetails
} from './actions';
import ManageCourse from '../../components/manage-course/index';
import { deselectCourses } from '../assign-courses/actions';

class ManageDefaultCourses extends Component {
    static propTypes = {
        fetchingCourse: PropTypes.bool,
        getDefaultCourses: PropTypes.func,
        saveDefaultCourses: PropTypes.func,
        isDefaultCoursesLoaded: PropTypes.bool,
        selectedProduct: PropTypes.object,
        onSuccessfulSave: PropTypes.bool,
        deselectCourses: PropTypes.func
    }

    componentDidMount() {
        this.props.getDefaultCourses();
    }

    componentWillReceiveProps(nextProps) {
        const { isDefaultCoursesLoaded } = nextProps;

        if (!isDefaultCoursesLoaded && isDefaultCoursesLoaded !== this.props.isDefaultCoursesLoaded) {
            this.props.getDefaultCourses();
        }
    }

    deselectCourses = () => {
        this.props.deselectCourses();
    }

    saveDefaultCourses = (yearGroupCourses) => {
        this.props.saveDefaultCourses(yearGroupCourses);
    }

    render() {
        const { fetchingCourse, isDefaultCoursesLoaded } = this.props;
        const isFetching = (!isDefaultCoursesLoaded || fetchingCourse);

        return (
            <div>
                <ManageCourse
                    deselectCourses={this.deselectCourses}
                    fetching={isFetching}
                    handleOnSave={this.saveDefaultCourses}
                    {...this.props}
                />
            </div>
        );
    }
}

function mapStateToProps(state = {}) {
    return {
        ...state,
        defaultCourses: state.courseAdmin.defaultCourses,
        upfCourses: state.courseAdmin.upfCourses,
        isDefaultCoursesLoaded: state.courseAdmin.isDefaultCoursesLoaded,
        savingDefaultCourses: state.courseAdmin.savingDefaultCourses,
        onSuccessfulSave: state.courseAdmin.onSuccessfulSave,
        isCourseModalVisible: state.courseAdmin.isCourseModalVisible,
        courseDetails: state.courseAdmin.courseDetails,
        fetchingCourse: state.courseAdmin.fetchingCourse,
        selectedProduct: state.product,
        conquestCourses: state.courseAdmin.conquestCourses
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getDefaultCourses,
        saveDefaultCourses,
        showCourseDetails,
        hideCourseDetails,
        deselectCourses
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ManageDefaultCourses));



// WEBPACK FOOTER //
// ./app/containers/manage-default-courses/manage-default-courses.js